import type { RouteParams, RouteParamValue } from 'vue-router'
import type { Currency, Country } from '@core/plugins/master-data/types'

function processAmount(amount: unknown): number | undefined {
  const number = Number(amount)
  if (Number.isNaN(number)) {
    return undefined
  }
  return number > 0 ? number : undefined
}

export function countryFromParam(
  param: RouteParamValue | RouteParamValue[] | undefined,
  countries: Map<string, Country>,
  countrySlugIsoMap: Map<string, string>,
) {
  if (typeof param !== 'string') {
    throw new NotFoundError(`Invalid country param ${JSON.stringify(param)}`)
  }
  const country =
    param.length === 2
      ? countries.get(param.toUpperCase())
      : countries.get(countrySlugIsoMap.get(param.toLowerCase()) ?? '')
  if (!country) {
    throw new NotFoundError(`Country ${JSON.stringify(param)} does not exist`)
  }
  return country
}

export function currencyFromParam(
  param: string | string[] | undefined,
  currencies: Map<string, Currency>,
) {
  const iso = String(param).toUpperCase()
  return currencies.get(iso)
}

export function processIMTParams(params: RouteParams) {
  const {
    $masterData: { countries, countrySlugIsoMap, currencies },
  } = useNuxtApp()

  const countryFrom = countryFromParam(params.countryFrom, countries, countrySlugIsoMap)
  const countryTo = countryFromParam(params.countryTo, countries, countrySlugIsoMap)
  const currencyFrom = currencyFromParam(params.currencyFrom, currencies)
  const currencyTo = currencyFromParam(params.currencyTo, currencies)
  if ((params.currencyFrom && !currencyFrom) || (params.currencyTo && !currencyTo)) {
    throw new NotFoundError(`Invalid currency params ${JSON.stringify(params)}`)
  }
  const amount = processAmount(params.amount)

  return {
    countryFrom,
    countryTo,
    currencyFrom,
    currencyTo,
    amount,
  }
}
